module.exports = __webpack_public_path__ + "img/header-user-sp.381f7c61.png";